var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _path17, _path18, _circle3, _circle4, _path19, _circle5, _circle6, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259 264",
    fillRule: "evenodd",
    clipRule: "evenodd",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6f5ff",
    stroke: "#18191b",
    d: "M34.5 19h205v192h-205z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 214.5l-14.426-61H203.5l14.043 61h9.957z",
    fill: "#7ec4f6",
    stroke: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 222.5l35-74.5H208l-34.5 74.5h-13z",
    fill: "#fff",
    stroke: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 222.5l-29-74.5H214l29.5 74.5h-13z",
    fill: "#fff",
    stroke: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M156 64h92v88h-92z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 156H254l-6-4H147l4.5 4z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce7ff",
    stroke: "#18191b",
    d: "M172 95h15v18h-15z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ec4f6",
    stroke: "#18191b",
    d: "M187 80h15v33h-15z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce7ff",
    stroke: "#18191b",
    d: "M202 86h14v27h-14z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ec4f6",
    stroke: "#18191b",
    d: "M216 72h15v41h-15z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M254 72.5l-6-8.5v88l6 4V72.5z",
    fill: "#7ec4f6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd7fe",
    stroke: "#18191b",
    d: "M172 120h59v5h-59z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ac94fa",
    stroke: "#18191b",
    d: "M172 128h35v5h-35z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd7fe",
    stroke: "#18191b",
    d: "M172 136h47v5h-47z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M53.5 158h83v105h-83z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63 173h48m-48 5.5h28m-28 66h28m-28-50h63m-63 5h63m-63 5h63m-63 5h35m-35 11h63m-63 5h50m-50 25h35",
    fill: "none",
    stroke: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 253l4.5-13.5 6.5 1.5-4 15-2.5-5.5-4.5 2.5z",
    fill: "#7ec4f6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130 253l-4.5-13.5-6.5 1.5 4 15 2.5-5.5 4.5 2.5z",
    fill: "#7ec4f6",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 238.5,
    r: 8.5,
    fill: "#cce7ff",
    stroke: "#18191b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72.5,
    r: 71.5,
    fill: "#fff",
    stroke: "#18191b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72 .5a71.993 71.993 0 0158.249 29.68 71.998 71.998 0 0110.227 64.569L72 72.5V.5z",
    fill: "#dcd7fe",
    stroke: "#18191b",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72 .5a72.003 72.003 0 0142.321 13.751L72 72.5V.5z",
    fill: "#ac94fa",
    stroke: "#18191b",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 237.146 4.353)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 204 225.5)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M234 243a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 00234 243z",
    fill: "none",
    stroke: "#18191b"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 143.146 8.353)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 257 13.353)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.735 20.571L223.592 2H179.5v28.224l21.235-9.653z",
    fill: "#104c8b",
    stroke: "#18191b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ec4f6",
    stroke: "#18191b",
    d: "M224.5 2h-45v25h45z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186 21.5l9.145-8.5 11.686 6.5L217.5 9m0 0h-5.081m5.081 0v5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBoardRoom;